import { QuoteType } from '@/lib/types'

type PaymentMilestoneEditability = {
  dsy_percent_was_null?: boolean
}

export function isPaymentMilestoneEditable(milestone: PaymentMilestoneEditability) {
  return !milestone.dsy_percent_was_null
}

export function hasAmountOnlyPaymentMilestones(milestones: PaymentMilestoneEditability[]) {
  return milestones.some((milestone) => !isPaymentMilestoneEditable(milestone))
}

export function shouldUseDefaultPaymentMilestones({
  milestones,
  quoteType,
  summaryTotal,
}: {
  milestones: PaymentMilestoneEditability[]
  quoteType?: QuoteType | number
  summaryTotal: number
}) {
  if (hasAmountOnlyPaymentMilestones(milestones)) return false
  if (quoteType === QuoteType.Budget) return false
  if (quoteType === QuoteType.ChangeOrder && summaryTotal === 0) return false
  return true
}
